;
(function(){
  var sticky = document.getElementById('bs4Sticky');
  if(sticky){
    var shown = false;
    var comparisonTop = null;
    function getComparisonTop(){
      var el = document.querySelector('.bs4-table-wrap') || document.querySelector('[class*="compar"]');
      return el ? (el.getBoundingClientRect().top + window.pageYOffset) : 1200;
    }
    function checkScroll(){
      if(shown) return;
      var y = window.pageYOffset;
      var threshold = getComparisonTop() - (window.innerHeight * 0.5);
      if(y > threshold){ sticky.classList.add('bs4-sticky-visible'); shown = true; }
    }
    window.addEventListener('scroll', checkScroll, {passive:true});
    checkScroll();
  }
  var faqBtns = document.querySelectorAll('.bs4-faq-q');
  for(var i = 0; i < faqBtns.length; i++){
    faqBtns[i].addEventListener('click', function(){
      var a = this.nextElementSibling;
      var arrow = this.querySelector('.bs4-faq-arrow');
      if(a.style.display === 'block'){
        a.style.display = 'none';
        if(arrow) arrow.style.transform = 'rotate(0deg)';
      } else {
        a.style.display = 'block';
        if(arrow) arrow.style.transform = 'rotate(45deg)';
      }
    });
  }
  var posters = document.querySelectorAll('.bs4-vt-poster');
  for(var j = 0; j < posters.length; j++){
    posters[j].addEventListener('click', function(){
      var v = this.querySelector('video');
      var im = this.querySelector('img');
      var pl = this.querySelector('.bs4-vt-play');
      var tg = this.querySelector('.bs4-vt-tag');
      if(v){ v.style.display = 'block'; v.play(); }
      if(im) im.style.display = 'none';
      if(pl) pl.style.display = 'none';
      if(tg) tg.style.display = 'none';
    });
  }
})();
